import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService {
  private storage: Storage;

  constructor() {
    this.storage = sessionStorage;
  }

  public set<T>(key: string, value: T): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  public get(key: string) {
    try {
      return JSON.parse(this.storage.getItem(key) as string);
    } catch (e) {
      return this.storage.getItem(key);
    }
  }

  public remove(key: string): void {
    this.storage.removeItem(key);
  }

  public clear(): void {
    this.storage.clear();
  }
}
